import styled from '@emotion/styled';
import React, { ReactElement } from 'react';
import { UserSubscriptionPlanStatus } from '../../../../ReduxStorage/UserSubscriptionPlans/constants';
import { OL_COLOUR_KELP, OL_COLOUR_TOMAHTO } from '../../Style/colours';

interface BillingStatusProps {
  status: UserSubscriptionPlanStatus;
  label: string;
  cancelAtPeriodEnd?: boolean;
}

type StatusContainerProps = {
  width: number;
  background: string;
};

const StatusContainer = styled('div')<StatusContainerProps>((props) => ({
  width: props.width,
  height: 20,
  borderRadius: 4,
  backgroundColor: props.background,
  color: 'white',
  textAlign: 'center',
  fontWeight: 'bold',
}));

export const BillingStatus = React.memo(
  ({ status, label, cancelAtPeriodEnd }: BillingStatusProps): ReactElement => {
    let background = '#CACACA';

    switch (status) {
      case 'active':
        background = OL_COLOUR_KELP;
        break;
      case 'trial':
        background = '#EE9105';
        break;
      case 'expired':
      case 'cancelled':
        background = OL_COLOUR_TOMAHTO;
        break;
      default:
    }

    return (
      <StatusContainer
        width={cancelAtPeriodEnd ? 120 : 83}
        background={cancelAtPeriodEnd ? OL_COLOUR_TOMAHTO : background}
      >
        {cancelAtPeriodEnd ? 'CANCELLED' : label}
      </StatusContainer>
    );
  }
);
